<template>
    <div class="article-detail">
        <div class="banner">
            <div class="title">最新文章</div>
        </div>

        <div class="article-detail-wrap container">
            <div class="breadcrumbs">
                <router-link :to="{ name: 'article'}">
                    <label class="clickable">最新文章</label>
                </router-link>
                <img src="@/assets/img/landingPage/arrow_right.svg"/>
                <label>文章詳情</label>
            </div>
            <div class="title">
                <div>{{article.title}}</div>
            </div>
            <div class="tags-list">
                <div class="tag" v-for="(tag, index) in article.tags" :key="index">{{tag}}</div>
            </div>
            <div class="cover" v-bind:style="{backgroundImage:'url(' + article.cover + ')'}"></div>
            <div class="content">
                <div class="paragraph" v-for="(paragraph, index) in article.content" :key="index" v-bind:class="{ 'text-red': paragraph.redColor}">{{paragraph.word}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted () {
        this.$analytics.logEvent("文章內頁", {
            screen_name: "文章內頁"
        });
    },
    components: {

    },
    data () {
        return {
            article: {
                cover: 'https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_4.jpeg',
                title: '飛豬管家，物管公司分享產品使用心得',
                tags: ['找房','物業管理','管家','租屋','租房','包租代管'],
                content: [
                  {
                    word: '台灣節節高升的房價，使得越來越多人購屋無望轉買為租，租屋已經成為了一種趨勢。租賃市場需求擴大，眾多的包租代管公司如雨後春筍般的成立，系統管理的需求也迫切產生。',
                    redColor: false
                  },
                  {
                    word: '飛豬管家在2021年2月推出企業版，已有好幾家物業管理公司進行合作，這次特別訪談到了在不動產租賃市場有10幾年經驗，從一開始管理20間房源到現在管理幾百間房源的皇嘉物業管理顧問股份有限公司、負責人楊晴惠，使用這套租賃管理系統後的心得分享：',
                    redColor: false
                  },
                  {
                    word: '飛豬：是什麼原因讓您想導入飛豬管家企業系統',
                    redColor: true
                  },
                  {
                    word: '皇嘉：原本作業有太多重複性的工作，需要花費很多時間跟人力，希望有一套更有效率的系統來減少人工作業跟減少錯誤，讓員工的價値，發揮在核心業務上，為公司創造業績，將心力放在提供房客或屋主更好的服務，才有可能提升產業整體價値。',
                    redColor: false
                  },
                  {
                    word: '飛豬：市面上不乏相似的產品，選擇飛豬管家的理由是什麼？',
                    redColor: true
                  },
                  {
                    word: '皇嘉：比較過幾個提供類似服務的平台，發現飛豬管家有租客專屬的找房APP，且可以免費刊登廣告。提供的功能比較全面且貼近物管公司需求。除了一般常見的房源跟帳務報表、線上簽立電子合約等功能之外，還有自動產生屋主對帳單跟委託房客的功能。',
                    redColor: false
                  },
                  {
                    word: '飛豬：剛開始使用時，有遇到什麼困難嗎？',
                    redColor: true
                  },
                  {
                    word: '皇嘉：因為過去從來沒有使用過類似的系統，且功能還不熟悉，一開始公司同仁在使用時有點抗性，但在經過一段時間的了解跟摸索過後，現在同仁已經滿依賴使用飛豬管家，把節省的時間用來處理其他事情。',
                    redColor: false
                  },
                  {
                    word: '飛豬：在合約與租約管理上跟以往有很大的差異嗎？',
                    redColor: true
                  },
                  {
                    word: '皇嘉：在租客訂房，可以瀏覽預訂房客的評價，大大提升租房成功率跟後續的管理容易度。不只進行中的租約很方便管理，就連已結束的租約記錄也清楚記載，減少人工及紙本作業翻找過往的記錄，除了便利外，飛豬管家也提供數據統計跟報表分析，同時與同行做出區別。',
                    redColor: false
                  },
                  {
                    word:'飛豬：目前覺得最好用的功能是哪一項？',
                    redColor: true
                  },
                  {
                    word:'皇嘉：其實每項功能對於原先傳統方式皆須要人工作業來說方便許多，像是自動新增電子帳單，線上催繳，現在都是飛豬管家自動處理的，相對以往光是每月製作跟寄發紙本帳單，還有電話催繳，人力就節省很多。加上每月自動產生屋主對帳單，更是大幅減少行政作業人力跟錯誤率。最重要的是委託房客這個功能，可以提前出租，降低業務帶看工作量的同時還能降低空房率是很値得推薦的創新功能。',
                    redColor: false
                  },
                  {
                    word:'飛豬：以老闆角度來看這套系統，對於管理上帶來什麼樣的幫助？',
                    redColor: true
                  },
                  {
                    word:'皇嘉：系統提供清晰的租金收支帳表、客製化記帳功能、屋主對帳表、快速了解各業務區域的空房率、業績與開發量，且能隨時掌握各業務的待辦事項，讓管理階層容易發現問題並針對問題改善。同時方便進行待辦跟催與活動量管理，即使在外也可以辦公，管理更加方便。',
                    redColor: false
                  },
                  {
                    word:'飛豬：使用後覺得改變最大幫助最多的是什麼？',
                    redColor: true
                  },
                  {
                    word:'皇嘉：這套系統帶來了良性的循環，因為降低公司業務的工作量，有更多時間在開發案件跟屋主，因此公司的案件量逐漸增加了，也增加各業務的良性競爭。',
                    redColor: false
                  },
                  {
                    word:'飛豬：未來如要開發新功能，最希望平台增加什麼樣的新功能？',
                    redColor: true
                  },
                  {
                    word:'皇嘉：希望能有房客留言功能，能線上接收及回覆房客疑問，或是收到房客找房需求，讓租屋媒合及溝通更多元。',
                    redColor: false
                  },
                ]
            }
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .article-detail {
        margin-bottom: 40px;
        .banner {
            display: none;
        }
        .container {
            width: 911px;
            margin-left: auto;
            margin-right: auto;
            box-sizing: border-box;
        }
        .article-detail-wrap {
            .breadcrumbs {
                margin-top: 40px;
                label.clickable {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #b1b0b0;
                    cursor: pointer;
                }
                label.clickable:hover {
                    color: #7d7979;
                }
                label{
                    font-size: 16px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #474342;
                    cursor: unset;
                }
                img {
                    margin-left: 12px;
                    margin-right: 12px;
                }
            }
            .title {
                margin-top: 34px;
                margin-bottom: 28px;
                div {
                    font-size: 26px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                }
            }
            .tags-list {
                margin-bottom: 20px;
                .tag {
                    display: inline-block;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #838282;
                    padding: 6px 14px;
                    border-radius: 5px;
                    background-color: #f1f3f6;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
            .cover {
                height: 400px;
                width: auto;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
            }
            .content {
                margin-top: 40px;
                .paragraph {
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #353535;
                    margin-bottom: 32px;
                }
                .text-red {
                  color: #F54F22;
                }
            }
        }
    }
    @media screen and (max-width: 1100px){
        .article-detail {
            .banner {
                display: block;
                position: relative;
                margin-bottom: 14px;
                height: 198px;
                width: 100%;
                background-image: url('https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;

                .title {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 24px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #ffffff;
                }
            }
            .container {
                width: unset;
                padding: 0 20px;
            }
            .article-detail-wrap {
                .breadcrumbs {
                    display: none;
                }
                .cover {
                    height: 207px;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/officailPage/article/articleDetail_4.vue